<template>
  <div>
    <!-- 自定义的播放提示模态框 -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>欢迎访问本站</h2>
        <p>请选择是否播放背景音乐：</p>
        <div class="button-group">
          <button @click="playMusic">播放音乐</button>
          <button @click="skipMusic">不播放音乐</button>
        </div>
      </div>
    </div>

    <!-- 控制播放/暂停的按钮 -->
    <div v-if="!showModal" class="controls">
      <button @click="toggleMusic">{{ isPlaying ? '暂停音乐' : '播放音乐' }}</button>
    </div>

    <!-- 背景音乐 -->
    <audio ref="backgroundMusic" preload="auto" :autoplay="isPlaying" loop>
      <source :src="audioSrc" type="audio/mpeg">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
export default {
  name: 'BackgroundMusicModal',
  data() {
    return {
      audioSrc: require('@/assets/music/mixkit-beautiful-dream-493.mp3'), // 音频文件路径
      showModal: true, // 控制弹窗显示
      isPlaying: false // 音乐的播放状态
    };
  },
  methods: {
    // 播放音乐
    playMusic() {
      this.isPlaying = true;
      const audio = this.$refs.backgroundMusic;
      if (audio) {
        audio.play(); // 播放音频
      }
      this.showModal = false; // 播放后关闭弹窗
      this.saveMusicState(true); // 保存状态为播放
    },
    // 不播放音乐
    skipMusic() {
      this.showModal = false; // 关闭弹窗
      this.saveMusicState(false); // 保存状态为不播放
    },
    // 切换播放与暂停状态
    toggleMusic() {
      this.isPlaying = !this.isPlaying;
      const audio = this.$refs.backgroundMusic;
      if (this.isPlaying) {
        audio.play();
      } else {
        audio.pause();
      }
      this.saveMusicState(this.isPlaying); // 保存当前状态
    },
    // 保存音乐播放状态到 localStorage
    saveMusicState(state) {
      localStorage.setItem('musicState', JSON.stringify(state));
    },
    // 加载音乐播放状态
    loadMusicState() {
      const state = localStorage.getItem('musicState');
      if (state !== null) {
        this.isPlaying = JSON.parse(state);
      }
    }
  },
  mounted() {
    // 页面加载时检查音乐播放状态
    this.loadMusicState();
  }
};
</script>

<style scoped>
/* 模态框的样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 弹窗内容样式 */
.modal-content {
  background: white;
  padding: 20px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 300px;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

/* 按钮样式 */
button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  width: 120px;
}

button:hover {
  background-color: #45a049;
}

button:focus {
  outline: none;
}

/* 播放/暂停按钮样式 */
.controls {
  position: fixed;  /* 使用 fixed 定位，使按钮始终处于页面固定位置 */
  bottom: 20px;     /* 距离页面底部20px */
  right: 20px;      /* 距离页面右边20px */
  z-index: 1000;    /* 确保按钮在其他元素之上 */
  text-align: center;
}

.controls button {
  background-color: #008CBA;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 18px;
  cursor: pointer;
  border-radius: 5px;
}

.controls button:hover {
  background-color: #007B9E;
}

.controls button:focus {
  outline: none;
}
</style>
